import * as actionTypes from "../actions/actionTypes";

import {
  storeTimelineValues,
  updatePost,
  createPost,
  deletePost,
  publishPost,
  pageIncreament,
  clearAll,
  storeSinglePost,
  clearSinglePost,
  getTimelineVideos,
  getTimelineMessageTemplates,
  getLatestRecognition,
  setLoader,
  updateSinglePost,
  createPostEnd,
  getAvatars,
  getSounds
} from "../utility/timelineFunctions";

const initialState = {
  timeline: [],
  avatars: [],
  sounds: [],
  introVideos: [],
  outroVideos: [],
  messageTemplates: [],
  latestRecognition: null,
  post: [],
  total: "",
  isLoading: true,
  page: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_TIMELINE:
      return storeTimelineValues(state, action.timeline, action.total);

    case actionTypes.UPDATE_POST:
      return updatePost(state, action.post);

    case actionTypes.UPDATE_SINGLE_POST:
      return updateSinglePost(state, action.post);

    case actionTypes.SET_LOADER:
      return setLoader(state, action.loaderValue);

    case actionTypes.CREATE_POST:
      return createPost(state, action.post);

    case actionTypes.CREATE_POST_END:
      return createPostEnd(state, action.post);

    case actionTypes.DELETE_POST:
      return deletePost(state, action.post);

    case actionTypes.PUBLISH_POST:
      return publishPost(state, action.post);

    case actionTypes.PAGE_INCREAMENT:
      return pageIncreament(state);

    case actionTypes.CLEAR_ALL:
      return clearAll(state);

    case actionTypes.GET_SINGLE_POST:
      return storeSinglePost(state, action.post);

    case actionTypes.CLEAR_SINGLE_POST:
      return clearSinglePost(state);

    case actionTypes.GET_TIMELINE_INTRO_VIDEOS:
      return getTimelineVideos(state, action.videos, "intro");

    case actionTypes.GET_TIMELINE_OUTRO_VIDEOS:
      return getTimelineVideos(state, action.videos, "outro");

    case actionTypes.GET_TIMELINE_MESSAGE_TEMPLATES:
      return getTimelineMessageTemplates(state, action.messages);

    case actionTypes.GET_LATEST_RECOGNITION:
      return getLatestRecognition(state, action.latestRecognition);

    case actionTypes.GET_AVATARS:
      return getAvatars(state, action.avatars);

    case actionTypes.GET_SOUNDS:
      return getSounds(state, action.sounds);

    default:
      return state;
  }
};

export default reducer;
